export const USER_TYPES = {
  ADMIN: 'Admin',
  CALLER: 'Caller',
  TALKING_BUDDY: 'TalkingBuddy',
};
export const USER_STATUS = {
  ALL: '',
  BLOCKED: 'true',
  UNBLOCKED: 'false',
};

export const TABLE_PARAM = {
  PAGE_SIZE: 10,
  PAGE_NUMBER: 1,
  SORT_ASC_ORDER: 'asc',
  SORT_DEC_ORDER: 'desc',
  ROW_PER_PAGE: [10, 20, 50, 100],
};

export const INVOICE_STATUS = ['PAID', 'PENDING', 'FAILED'];

export const STATUSES = {
  RESOLVED: 'Resolved',
  OPEN: 'Open',
  IN_REVIEW: 'In-Review',
  ON_HOLD: 'On-hold',
  UNDER_REVIEW: 'Under Review',
  UNDER_REVIEW_VALUE: 'UnderReview',
  CLOSED: 'Closed',
  PAID: 'Paid',
  PENDING: 'Pending',
  FAILED: 'Failed',
  REFUNDED: 'Refunded',
  DECLINED: 'Declined',
  NO_DISPUTE: 'No Request',
  OPEN_REQUEST: 'Open Request',
  SUCCESS: 'Success',
  FAIL: 'Fail',
  ERROR: 'Error',
  WARNING: 'Warning',
  INFO: 'Information',
};

export const SENT_TO_TYPE = {
  ALL_USERS: 'All users',
  ALL_TALKING_BUDDIES: 'All talking-buddies',
  ALL_CALLERS: 'All callers',
};

export const WEEK_DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const PREFERENCE_ITEMS = {
  GENDER: 'Gender',
  AGE_RANGE: 'Age Range',
  VIDEO_CALL: 'Allow Video Call',
  ALL_RECORDINGS: 'Allow Recording',
  COUNTRY: 'Country',
  STATE_PROVINCE: 'State/Province',
  LANGUAGE: 'Language',
  HIDE_NAME: 'Hide Name',
  HIDE_IMAGE: 'Hide Profile Image',
};

export const GENDER_PREFERENCE = {
  ANY: 'Any',
  NON_BINARY: 'Non-Binary',
  PREFER_NOT_TO_SAY: 'PreferNotToSay',
  FEMALE: 'Female',
  MALE: 'Male',
};

export const RECORDING_STATUSES = {
  NOT_INITIATED: 'NotInitiated',
  IN_PROGRESS: 'Inprogress',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
};
